import { createContext } from 'react'

export const OrderContext = createContext<{
    isImOrder: boolean | null
    isImReorder: boolean | null | undefined
}>({
    isImOrder: null,
    isImReorder: null,
})

export const HtsFormContext = createContext<{
    isImOrder: boolean | null
    isAnylineWithProcessName: boolean | undefined
}>({
    isImOrder: null,
    isAnylineWithProcessName: undefined,
})
